const appBarLabels = {
  "app.bar.latest": "Novedades",
  "app.bar.progress": "Progreso",
  "app.bar.leaderboard": "Clasificación",
  "app.bar.challenges": "Desafíos",
  "app.bar.team": "Equipo",
  "app.bar.activity": "Actividad",
  "app.bar.settings": "Configuración",
};

export const appBar = {
  ...appBarLabels,
};
